import * as utils from '@/lib/utils';

export default class MockHipAPI {
    private readonly initTS: number;

    private constructor() {
        this.initTS = new Date().getTime();
    }

    private static instance: MockHipAPI;

    public static getInstance() {
        if (!MockHipAPI.instance) {
            MockHipAPI.instance = new MockHipAPI();
        }
        return MockHipAPI.instance;
    }

    getRidesAtDate() {
        return Promise.resolve([
            {
                rideId: 1,
                actualDeparture: '07:30:08',
                actualArrival: null,
                plannedDeparture: '07:30:00',
                plannedArrival: '08:52:24',
                boardedPassengers: 7,
                nonBoardedPassengers: 0,
                routeName: 'Riverdale, NJ - New York City, NY',
                hasEnded: false,
                hasStarted: true,
                extraDetails: {
                    rideStops: [{
                        actualArrival: '08:51:58',
                        actualAtopTimeSec: 0,
                        estArrival: '08:51:58',
                    }],
                },
            },
            {
                rideId: 2,
                actualDeparture: '08:00:17',
                actualArrival: null,
                boardedPassengers: '7',
                nonBoardedPassengers: 0,
                plannedDeparture: '08:00:00',
                plannedArrival: '08:48:43',
                routeName: 'Hackensack, NJ - New York City, NY',
                hasEnded: false,
                hasStarted: true,
                extraDetails: {
                    rideStops: [{
                        actualArrival: '08:50:58',
                        actualAtopTimeSec: 0,
                        estArrival: '08:50:58',
                    }],
                },
            },
        ]);
    }

    getOngoingRides() {
        return Promise.resolve([
            {
                rideId: 1,
                rideStatus: {
                    rideId: 1,
                    status: 'ongoing',
                    currentStopName: null,
                    nextStopName: 'New York City, NY',
                    awaitingForCount: 5,
                    boardedCount: 3,
                },
                vehicleLocationData: {
                    lat: (Number('40.919733') - ((new Date().getTime() - this.initTS)) / 10000000).toString(),
                    long: (Number('-73.966481') - ((new Date().getTime() - this.initTS)) / 10000000).toString(),
                    rideId: 1,
                },
            },
            {
                rideId: 2,
                rideStatus: {
                    rideId: 2,
                    status: 'ongoing',
                    currentStopName: null,
                    nextStopName: 'New York City, NY',
                    awaitingForCount: 10,
                    boardedCount: 4,
                },
                vehicleLocationData: {
                    lat: (Number('40.890174') - ((new Date().getTime() - this.initTS)) / 10000000).toString(),
                    long: (Number('-74.016512') - ((new Date().getTime() - this.initTS)) / 10000000).toString(),
                    rideId: 2,
                },
            },
        ]);
    }

    getUsers() {
        return Promise.resolve({
            users: [{
                userId: 609,
                auth0Id: 'ea8d17d2f1724bbc98ff32b438c46d40',
                created: '2019-03-24 15:59:21',
                lastModified: '2020-08-09 17:25:56',
                isVerified: true,
                isSuspended: false,
                fullName: 'Artuditu2',
                email: 'aaa@bbb.ccc',
                phone: '8888888888',
                countryCode: '1',
                stripeCustomerId: 'cus_FgiTW2Gxgri5hp',
                referredByUserId: null,
                pushToken: 'eoRZEyYWPac:APA91bG3mhA4rgnUAmAxf1NoEisRZALU-lB_bg2wmaH9SQ1bLfORA4Pgq4OZesFWjE-9MC7pVuSnAFE5u5J0VStZWq5cc8NfczWYj2AXSEh68aJyH0LGU9kkp_dphPImegCS88MrFsGD',
                operatingSystem: 'android(28)',
                referralCode: 'qqq59f2b1',
                appVersion: '1.9.20+366-debug',
                notificationsOperational: 'push',
                notificationsMarketing: 'push',
                corpUserId: 1,
                corpOfficeId: 1,
                stopId: null,
            }, {
                userId: 2552,
                auth0Id: 'fb3cb06c0a874b4eb75443e14db90d74',
                created: '2020-06-17 10:44:40',
                lastModified: '2020-08-02 09:39:05',
                isVerified: true,
                isSuspended: false,
                fullName: 'Vhjn',
                email: 'jonathan@ridehip.com',
                phone: '0546999008',
                countryCode: '972',
                stripeCustomerId: 'cus_HTwf1ilrV8dmmH',
                referredByUserId: null,
                pushToken: 'dAkYD2UKFhE:APA91bFp1wUdPQ2zhF3TzZDI_8XamD0VSR5K2WSwg-2AgNPjTG2EUIY6Kr4Gxpu6y0a0joJx0pmb915FA8C0frfP_ax27kpNMvwgk2PQ5tjrd60_b6zQdIQUJ7edZVv8NQoXhxjwlb2h',
                operatingSystem: 'android(29)',
                referralCode: 'vhjnb80ea',
                appVersion: '1.9.17+363-staging',
                notificationsOperational: 'push',
                notificationsMarketing: 'push',
                corpUserId: 2,
                corpOfficeId: 1,
                stopId: null,
            }, {
                userId: 2598,
                auth0Id: 'f76fb3c51d4b4d4dbef94dea971dd796',
                created: '2020-07-30 10:37:01',
                lastModified: '2020-08-01 10:37:18',
                isVerified: true,
                isSuspended: false,
                fullName: 'Test corp',
                email: 'test0130072020@mailinator.com',
                phone: '0130072020',
                countryCode: '1',
                stripeCustomerId: null,
                referredByUserId: null,
                pushToken: 'di0ThH6Tt0Y:APA91bGk99cFlKoA4aH0Obgo3m25x3b2EknPYNSIpfEGqyjzi42ArwTpxVoMVVsoe9unzdfz49gvzzOF0u2kWrpU6LZVVLDQe_FrwAvw05zo5_vZN-oDwXxfi572GKHxC107wsFS46xC',
                operatingSystem: 'ios(13.2)',
                referralCode: 'testc31d1',
                appVersion: '1.9.19+365-staging',
                notificationsOperational: 'push',
                notificationsMarketing: 'push',
                corpUserId: 3,
                corpOfficeId: 1,
                stopId: null,
            }],
            preRegisteredUsers: [],
        });
    }

    getAllCorpOffices() {
        return Promise.resolve([
            {
                id: 1,
                name: 'Demo',
                corpId: 1,
                created: '2020-07-20 12:27:54',
                pickupStopId: 9,
                dropoffStopId: 13,
                corpName: "Hershey's",
                corpLogo: 'corning.png',
                tz: 'America/New_York',
                pickupStopName: 'State & Teaneck',
                dropoffStopName: 'DeGraw & Woodbine',
                pickupStopLat: '40.873880',
                pickupStopLong: '-74.017330',
                dropoffStopLat: '40.873880',
                dropoffStopLong: '-74.017320',
                pickupAddress: 'State & Teaneck',
                dropoffAddress: 'DeGraw & Woodbine',
            },
            {
                id: 2,
                name: 'Rehovot',
                corpId: 1,
                created: '2020-08-04 11:51:13',
                pickupStopId: 10,
                dropoffStopId: 15,
                corpName: "Hershey's",
                corpLogo: 'corning.png',
                tz: 'America/New_York',
                pickupStopName: 'Teaneck & Grayson',
                dropoffStopName: 'DeGraw & Woodbine (NE)',
                pickupStopLat: '40.884910',
                pickupStopLong: '-74.017130',
                dropoffStopLat: '40.884910',
                dropoffStopLong: '-74.017120',
                pickupAddress: 'Teaneck & Grayson',
                dropoffAddress: 'DeGraw & Woodbine (NE)',
            }]);
    }

    getUserTickets() {
        return Promise.resolve([{
            ticketId: 6765,
            userId: 2702,
            bookingId: 6187,
            ticketDate: '2020-10-22',
            routeScheduleId: 79,
            pickupRouteStopId: 435,
            dropoffRouteStopId: 436,
            rideId: null,
            pickupRideStopId: null,
            dropoffRideStopId: null,
            ticketStatusId: 1,
            ticketStatus: 'valid',
            otherWayTicketId: null,
            scheduleTimeDesc: 'Evening',
            isValidTicket: 1,
            routeScheduleEstDeparture: '12:30:00',
            routeScheduleEstArrival: '12:55:49',
            routeId: 36,
            routeName: 'Ness Ziona - Modiin',
            tz: 'Asia/Jerusalem',
            ridePlannedDeparture: null,
            ridePlannedArrival: null,
            consents: { health_commitment: null },
        }]);
    }
}
